import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStatus } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor(private http: HttpClient) { }
  getProjects(): Observable<IStatus> {
    return this.http.get<IStatus>('/api/Project/GetProjects');
  }

  getProjectsOnline(): Observable<IStatus> {
    return this.http.get<IStatus>('/api/Project/GetProjectsOnline');
  }
  getProjectsForChallan(): Observable<IStatus> {
    return this.http.get<IStatus>('/api/Project/GetProjectsForChallan');
  }
}
